import { ProductData } from 'utils/types';

const getIsLastInRow = (index: number, subProducts: ProductData[]) =>
  index + 1 === subProducts.length || (index + 1) % 4 === 0;

export const babaUtils = {
  getIsLastInRow,
};
